import { LocationType } from "./Enums";

export class EmailQuestionFormParameters {
    scheduleId: number = 0;
    dispatchId: number = 0;
    periodStartDate: string = '';
    periodEndDate: string = '';
    locationType: LocationType = LocationType.Origin;
} 